import React from 'react';

import { SelectField, TextAreaField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { objectToSelectList } from 'src/helpers';
import model from './model';
import NavigationButtons from './NavigationButtons';
import LANG_CONST from 'src/helpers/lang/const';

export default class SpecialityStep extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const { handleChangeProfile } = model;
    const { error, errorMessage, invalid, loading } = model.getApiState('updateSpecialist');

    return (
      <>
        {!!error && <p className='mc-error'>{errorMessage}</p>}
        <div className='mc-form mc-flex-col-20'>
          <SelectField
            template={6}
            width={'100%'}
            placeholder={'Enter keyword here'}
            label={LANG_CONST.speciality}
            description={LANG_CONST.text.speciality_des}
            isMultipleSpecial={true}
            isClearable={false}
            options={objectToSelectList(LANG_CONST.constants.specialist, true)}
            name={'specialist'}
            value={model.input('specialist')}
            onChange={handleChangeProfile}
            invalid={invalid}
          />
          <TextAreaField
            template={6}
            rows={4}
            name={'description'}
            label={LANG_CONST.description}
            placeholder={''}
            value={model.input('description')}
            onChange={handleChangeProfile}
            invalid={invalid}
          />
        </div>
        <NavigationButtons
          next={() => model.saveSpeciality((err) => !err && this.props.next())}
          loading={loading}
          labelNext={this.props.labelNext}
        />
      </>
    );
  }
}
